// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"SignalChip_iconAndTextGrouping__EMTlm"};